import { render } from "./OrderForm.vue?vue&type=template&id=d6a6dd3a&scoped=true"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"

import "./OrderForm.vue?vue&type=style&index=0&id=d6a6dd3a&scoped=true&lang=css"

import exportComponent from "/Users/ruisilva/Desktop/Projects/qmulher/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a6dd3a"]])

export default __exports__